// API-hulp voor de Singh-modules. Gekoppeld aan de kassa-login (cookie singh_session op /api/kassa).
import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/kassa/singh`;

export const api = axios.create({ baseURL: BASE, withCredentials: true });

// Na het Z-ticket van de kassa: dag in het digitale dagboek vergrendelen (409 = stond al afgesloten).
export async function sluitDagboek(params) {
  try { await api.post("/dagontvangsten/afsluiten", null, { params }); return null; }
  catch (e) { return e?.response?.status === 409 ? null : foutTekst(e); }
}

export const euro = (v) =>
  "€ " + Number(v || 0).toLocaleString("nl-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const getal = (v) =>
  Number(v || 0).toLocaleString("nl-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const foutTekst = (e) => e?.response?.data?.detail || e?.message || "Er ging iets mis";

// Download een bestand (PDF/CSV/ZIP) met de login-headers
export async function download(pad, params, bestandsnaam) {
  const r = await api.get(pad, { params, responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = bestandsnaam;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export const vandaagISO = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Brussels" });

export const datumLang = (iso) =>
  new Date(iso + "T12:00:00").toLocaleDateString("nl-BE", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
